import React, { useState } from "react";
import check from "../../../images/build-Check.svg";

const BusinessCategories = (props) => {
  const {
    categories,
    next,
    back,
    setCategories,
    selectedCategory,
    setSelectedCategory,
  } = props;

  const [showErrorMsg, setShowErrorMsg] = useState(false);

  const handleSubmit = () => {
    if (!selectedCategory) {
      setShowErrorMsg(true);
      return;
    }
    next({ categories: selectedCategory });
  };

  const onSelectCategory = (id) => {
    if (showErrorMsg) setShowErrorMsg(false);

    const modifiedCategories = categories.map((category) => {
      if (category.id === id) {
        category.selected = true;
        return category;
      }

      category.selected = false;
      return category;
    });

    setCategories(modifiedCategories);
    setSelectedCategory(id);
  };

  return (
    <div className="businessprofile-cover">
      <h2>Please select your Region </h2>
      <div className="businees-categories">
        <ul className="businees-categories-list">
          {categories.map((category) => (
            <li key={category.id}>
              <div
                className="categories-row"
                onClick={() => onSelectCategory(category.id)}
              >
                <div className="categories-img">
                  <img src={category.image_url_svg} alt="urban" />

                  {category.selected && (
                    <div className="build-active">
                      <span>
                        <img src={check} alt="check-mark" />
                      </span>
                    </div>
                  )}
                </div>
                <p>{category.name}</p>
              </div>
            </li>
          ))}
        </ul>
        {showErrorMsg && (
          <div className="error-message">Please select council category</div>
        )}
        <div className="form-submit">
          <button onClick={back} type="submit" className="back-btn">
            Back
          </button>
          <button onClick={handleSubmit} type="submit" className="submit-btn">
            Next
          </button>
        </div>
      </div>
    </div>
  );

  /* return (
    <Formik initialValues={props.data} onSubmit={handleSubmit}>
      {() => (
        <Form>
          <div className="businessprofile-cover">
            <h2>Please select your Region </h2>
            <div className="businees-categories">
              <ul className="businees-categories-list">
                <li>
                  <div className="categories-row">
                    <div className="categories-img">
                      <img src={rural} alt="rural" />
                      <div className="build-active">
                        <span>
                          <img src={check} alt="check-mark" />
                        </span>
                      </div>
                    </div>
                    <p>Rural</p>
                  </div>
                </li>
                <li>
                  <div className="categories-row">
                    <div className="categories-img">
                      <img src={urban} alt="urban" />
                      <div className="build-active">
                        <span>
                          <img src={check} alt="check-mark" />
                        </span>
                      </div>
                    </div>
                    <p>Urban</p>
                  </div>
                </li>
                <li>
                  <div className="categories-row">
                    <div className="categories-img">
                      <img src={regional} alt="regional" />
                    </div>
                    <p>Regional</p>
                  </div>
                </li>
              </ul>
              <div className="form-submit">
                <button onClick={props.back} type="submit" className="back-btn">
                  Back
                </button>
                <button type="submit" className="submit-btn">
                  Next
                </button>
              </div>
            </div>
          </div>
        </Form>
      )}
    </Formik> 

    
  ); */
};

export default BusinessCategories;
